/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const QuestionOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 17.81c.52 0 .94-.42.94-.94 0-.51-.42-.93-.94-.93s-.94.42-.94.93c0 .52.42.94.94.94z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12 13.5v-.75c.52 0 1.03-.15 1.46-.44s.77-.7.97-1.18c.19-.48.25-1.01.14-1.52-.1-.51-.35-.97-.71-1.34a2.623 2.623 0 0 0-4.48 1.85M21 12a9 9 0 1 1-18.001-.001A9 9 0 0 1 21 12z"
})); // Fill


const QuestionFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 2.25c-1.93 0-3.81.57-5.42 1.64-1.6 1.07-2.85 2.6-3.59 4.38s-.93 3.74-.55 5.63c.37 1.89 1.3 3.63 2.67 4.99 1.36 1.37 3.1 2.3 4.99 2.67 1.89.38 3.85.19 5.63-.55s3.31-1.99 4.38-3.59A9.78 9.78 0 0 0 21.75 12c0-2.59-1.03-5.06-2.86-6.89S14.58 2.25 12 2.25zM12 18c-.22 0-.44-.07-.63-.19-.18-.12-.32-.3-.41-.51-.08-.2-.11-.43-.06-.65.04-.21.15-.41.3-.57.16-.16.36-.27.58-.31s.44-.02.65.06a1.132 1.132 0 0 1 .7 1.04c0 .3-.12.59-.33.8-.22.21-.5.33-.8.33zm.75-4.59v.09a.75.75 0 0 1-1.5 0v-.75A.75.75 0 0 1 12 12c.37 0 .73-.11 1.04-.32.31-.2.55-.5.69-.84s.18-.72.11-1.08c-.07-.37-.25-.7-.51-.96a1.915 1.915 0 0 0-2.05-.41c-.34.14-.63.38-.84.69s-.31.67-.31 1.04a.75.75 0 0 1-.75.75c-.2 0-.39-.07-.54-.22a.74.74 0 0 1-.21-.53 3.35 3.35 0 0 1 1.91-3.04c.57-.27 1.21-.38 1.84-.31s1.23.32 1.72.72c.5.39.88.92 1.09 1.52s.24 1.25.1 1.87-.45 1.18-.9 1.63-1.02.76-1.64.9z"
})); // DuoTone


const QuestionDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 21a9 9 0 1 0-.001-18.001A9 9 0 0 0 12 21z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 18c.62 0 1.12-.5 1.12-1.13 0-.62-.5-1.12-1.12-1.12s-1.12.5-1.12 1.12c0 .63.5 1.13 1.12 1.13z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12 13.5v-.75c.52 0 1.03-.15 1.46-.44s.77-.7.97-1.18c.19-.48.25-1.01.14-1.52-.1-.51-.35-.97-.71-1.34a2.623 2.623 0 0 0-4.48 1.85M21 12a9 9 0 1 1-18.001-.001A9 9 0 0 1 21 12z"
}));
/**
  Icon QuestionIcon in security group
*/


export const QuestionIcon = createIcon('QuestionIcon', 'question', 'security', QuestionOutline, QuestionFill, QuestionDuotone, "0 0 24 24");